import { load } from '@redux/middleware/persist';
import { createSlice } from '@reduxjs/toolkit';
const persistedValue = load('shortlist.persisted', {
    items: [],
});
export const initialState = {
    persisted: persistedValue,
};
const slice = createSlice({
    initialState,
    name: 'shortlist',
    reducers: {
        add: (state, action) => {
            state.persisted.items = state.persisted.items.filter((r) => r.id !== action.payload.id);
            state.persisted.items.push(action.payload);
        },
        clear: (state) => {
            state.persisted.items = [];
        },
        remove: (state, action) => {
            state.persisted.items = state.persisted.items.filter((r) => r.id !== action.payload);
        },
        toggle: (state, action) => {
            if (state.persisted.items.find((r) => r.id === action.payload.id)) {
                state.persisted.items = state.persisted.items.filter((r) => r.id !== action.payload.id);
            }
            else {
                state.persisted.items.push(action.payload);
            }
        },
    },
});
export const { add, clear, remove, toggle } = slice.actions;
export const name = slice.name;
export const reducer = slice.reducer;
